<template>
  <ConsentNotice>
    <span>Die</span>
    <BaseLink
      url="https://www.istaexpress.de/nutzungsbedingungen.html"
      external
    >
      {{ "  " }} Nutzungsbedingungen
    </BaseLink>
    <span>{{ "  " }} und</span>
    <BaseLink url="https://www.istaexpress.de/datenschutz.html" external>
      {{ "  " }} Datenschutzerklärung
    </BaseLink>
    <span>{{ "  " }} der ista Express Service GmbH habe ich zur Kenntnis genommen.</span>
  </ConsentNotice>
</template>

<script setup lang="ts">
import BaseLink from '~/base/components/link/Link.vue'
import ConsentNotice from '~/base/components/consentNotice/ConsentNotice.vue'
</script>
